import { createContext, useContext, useRef } from "react";

interface UUIDContextValue {
    generateUniqueId: () => string;
}

const uuidContext = createContext<UUIDContextValue | null>(null);

export function useUUID() {
    const ctx = useContext(uuidContext);
    if (!ctx) throw new Error("useUUID must be used within UUIDProvider");
    return ctx;
}

interface Props {
    children: React.ReactNode;
}

function generateRandomId() {
    return "id" + Math.random().toString(16).slice(2);
}

export function UUIDProvider({ children }: Props) {
    const idList = useRef(new Set<string>());

    function generateUniqueId(): string {
        let id: string;
        do {
            id = generateRandomId();
        } while (idList.current.has(id));

        idList.current.add(id);
        return id;
    }

    return (
        <uuidContext.Provider
            value={{
                generateUniqueId,
            }}
        >
            {children}
        </uuidContext.Provider>
    );
}
